var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThirdMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.175 4.32C11.0931 3.32313 9.69187 2.66813 8.14437 2.52813L9.39562 0H14.3125L12.175 4.32ZM6.89312 2.52875L5.64562 0H0.663116L2.81687 4.36562C3.90437 3.34375 5.32312 2.67188 6.89312 2.52875ZM13.1456 9.375C13.1456 12.4769 10.6219 15 7.52062 15C4.41937 15 1.89562 12.4769 1.89562 9.375C1.89562 6.27313 4.41874 3.75 7.52062 3.75C10.6225 3.75 13.1456 6.27313 13.1456 9.375ZM9.79187 10.625C9.79187 10.0256 9.50874 9.49187 9.06999 9.14812C9.26249 8.85375 9.37499 8.5025 9.37499 8.125C9.37499 7.09125 8.53374 6.25 7.49999 6.25H5.93749V7.5H7.49999C7.84499 7.5 8.12499 7.78 8.12499 8.125C8.12499 8.47 7.84499 8.75 7.49999 8.75H6.87499V10H7.91687C8.26187 10 8.54187 10.28 8.54187 10.625C8.54187 10.97 8.26187 11.25 7.91687 11.25H5.93749V12.5H7.91687C8.95062 12.5 9.79187 11.6587 9.79187 10.625Z",
    fill: "#EBAF9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdMedal);
export default __webpack_public_path__ + "static/media/ThirdMedal.128c3c871562330700cad40dfaf0a72e.svg";
export { ForwardRef as ReactComponent };